var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrayPlanetBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 746,
    viewBox: "0 0 747 746",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_18483)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.872,
    cy: 373,
    rx: 332.697,
    ry: 332.811,
    fill: "url(#paint0_radial_2785_18483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.245 373C745.245 578.726 578.528 745.5 372.872 745.5C167.217 745.5 0.499979 578.726 0.499986 373C0.499994 167.274 167.217 0.500006 372.872 0.500014C578.528 0.500021 745.245 167.274 745.245 373Z",
    stroke: "#F2D861",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1842 227.316C29.3044 270.589 18.832 318.373 18.832 368.604C18.832 413.547 27.2154 456.531 42.5031 496.077",
    stroke: "url(#paint1_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.609 392.477C711.032 345.326 703.998 296.915 686.301 249.907C670.467 207.848 647.477 170.577 619.238 138.958",
    stroke: "url(#paint2_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.205 601.741C164.988 635.718 205.15 663.647 251.572 682.83C293.106 699.994 336.03 708.661 378.413 709.633",
    stroke: "url(#paint3_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.887 315.541C714.358 262.794 693.033 211.308 660.326 164.358C631.063 122.351 595.24 87.6369 555.202 60.6352",
    stroke: "url(#paint4_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.279 666.181C222.995 694.52 275.165 714.112 331.796 722.294C382.465 729.614 432.288 727.161 479.358 716.362",
    stroke: "url(#paint5_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.967 102.283C554.714 72.2253 510.799 49.1848 461.687 35.7351C417.746 23.7014 373.475 20.3943 330.717 24.763",
    stroke: "url(#paint6_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.826 714.766C471.225 708.089 518.05 691.753 561.419 665.07C600.222 641.196 632.877 611.121 658.892 576.908",
    stroke: "url(#paint7_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.852 88.2806C167.971 110.454 133.936 140.625 106.431 178.372C81.8226 212.146 64.5861 249.041 54.4208 287.136",
    stroke: "url(#paint8_linear_2785_18483)",
    strokeOpacity: 0.5,
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.137 372.372C548.137 468.855 469.949 547.069 373.5 547.069C277.051 547.069 198.863 468.855 198.863 372.372C198.863 275.889 277.051 197.675 373.5 197.675C469.949 197.675 548.137 275.889 548.137 372.372Z",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.004 373C690.004 548.207 548.019 690.241 372.872 690.241C197.725 690.241 55.7402 548.207 55.7402 373C55.7402 197.793 197.725 55.7593 372.872 55.7593C548.019 55.7593 690.004 197.793 690.004 373Z",
    stroke: "#F2D861",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.603,
    cy: 76.1476,
    rx: 400.603,
    ry: 76.1476,
    transform: "matrix(0.828476 -0.559981 0.524223 0.851625 -13.9814 490.105)",
    stroke: "url(#paint9_linear_2785_18483)",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.791,
    cy: 82.6383,
    rx: 280.791,
    ry: 82.6383,
    transform: "matrix(-0.957368 -0.288327 -0.147723 0.989197 646.911 476.038)",
    stroke: "url(#paint10_linear_2785_18483)",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.489654,
    y: -0.510179,
    width: 56.2973,
    height: 56.3004,
    rx: 28.1486,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 621.368 178.232)",
    fill: "url(#paint11_radial_2785_18483)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.979309,
    y: -1.02036,
    width: 91.632,
    height: 91.6371,
    rx: 45.816,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 604.391 196.753)",
    stroke: "#FDDC2D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.84823,
    cy: 4.84849,
    rx: 4.84823,
    ry: 4.84849,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 659.482 98.0984)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.20374,
    cy: 2.20386,
    rx: 2.20374,
    ry: 2.20386,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 633.638 214.148)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.471 209.198C645.575 209.115 648.97 212.375 649.053 216.48C649.137 220.585 645.877 223.981 641.773 224.065C637.669 224.148 634.275 220.888 634.191 216.783C634.108 212.678 637.367 209.282 641.471 209.198Z",
    stroke: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.489654,
    y: -0.510179,
    width: 97.5233,
    height: 97.5286,
    rx: 48.7616,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 600.632 198.938)",
    stroke: "#FDDC2D",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.49373,
    cy: 3.49392,
    rx: 3.49373,
    ry: 3.49392,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 600.026 115.775)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.49373,
    cy: 3.49392,
    rx: 3.49373,
    ry: 3.49392,
    transform: "matrix(-0.0203231 -0.999953 0.999632 -0.0204037 686.822 191.598)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.0148613,
    y: 0.707072,
    width: 42.0099,
    height: 42.0099,
    rx: 21.0049,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 48.5487 180.426)",
    fill: "url(#paint12_radial_2785_18483)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.0148613,
    y: 0.707072,
    width: 42.0099,
    height: 42.0099,
    rx: 21.0049,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 168.546 630.228)",
    fill: "url(#paint13_radial_2785_18483)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.0148613,
    y: 0.707072,
    width: 21.0675,
    height: 21.0675,
    rx: 10.5338,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 96.7821 510.122)",
    fill: "url(#paint14_radial_2785_18483)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.6393,
    cy: 3.6393,
    r: 3.6393,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 67.1777 244.365)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.65423,
    cy: 1.65423,
    rx: 1.65423,
    ry: 1.65423,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 22.4736 167.131)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.62255,
    cy: 2.62255,
    r: 2.62255,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 91.0283 204.366)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.87601,
    cy: 5.87601,
    r: 5.87601,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 7.22656 202.199)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.46193,
    cy: 8.46193,
    r: 8.46193,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 206.813 76.6106)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.46193,
    cy: 8.46193,
    r: 8.46193,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 62.4355 301.416)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 686.547 312.719)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.30709,
    cy: 9.30709,
    r: 9.30709,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 580.902 87.9136)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 720.442 497.335)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 264.709 722.139)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 133.339 595)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 352.592 675.671)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 577.319 676.927)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 39.9814 418.213)",
    fill: "#FDDC2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08416,
    cy: 5.08416,
    r: 5.08416,
    transform: "matrix(0.691969 0.721882 -0.721691 0.692262 609.962 565.153)",
    fill: "#FDDC2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2785_18483",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.872 373) rotate(90) scale(332.811 332.697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDC2D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23287,
    stopColor: "#FFF761",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522081,
    stopColor: "#FDDC2D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799724,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EB4BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2785_18483",
    x1: 33.5081,
    y1: 227.316,
    x2: 33.5081,
    y2: 496.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2785_18483",
    x1: 722.344,
    y1: 387.303,
    x2: 627.599,
    y2: 135.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2785_18483",
    x1: 126.602,
    y1: 615.306,
    x2: 375.002,
    y2: 717.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2785_18483",
    x1: 738.604,
    y1: 305.978,
    x2: 563.528,
    y2: 54.8307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2785_18483",
    x1: 174.893,
    y1: 682.731,
    x2: 477.91,
    y2: 726.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2785_18483",
    x1: 595.897,
    y1: 87.9245,
    x2: 333.113,
    y2: 16.0082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2785_18483",
    x1: 431.629,
    y1: 727.444,
    x2: 663.65,
    y2: 584.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2785_18483",
    x1: 194.824,
    y1: 80.239,
    x2: 47.5954,
    y2: 282.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2785_18483",
    x1: 400.603,
    y1: 0,
    x2: 400.603,
    y2: 152.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FBD161",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2785_18483",
    x1: 280.791,
    y1: 0,
    x2: 280.791,
    y2: 165.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#FBD161",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D861"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2785_18483",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6486 28.6502) rotate(90) scale(28.6502 28.6486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF761",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2785_18483",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5049 21.5049) rotate(90) scale(21.5049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF761",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2785_18483",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5049 21.5049) rotate(90) scale(21.5049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF761",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2785_18483",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0338 11.0338) rotate(90) scale(11.0338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF761",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_18483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747,
    height: 746,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPlanetBg);
export default __webpack_public_path__ + "static/media/gray-planet-bg.823cbf56a0615105a4a29a6fc96be157.svg";
export { ForwardRef as ReactComponent };